module.exports = ".node-form {\n  display: flex;\n  align-items: flex-start; }\n\n.node-form-selected {\n  display: flex;\n  align-items: center; }\n"